module.exports = __webpack_public_path__ + "static/testimonial1-5eb3e339a1e088242daa94026b882f1c.svg";